import { AppRoutes } from './routes/Routes';
const App = () => {
    return <AppRoutes />;
};

export { App };
